export default function Marquee({ content }) {
  const items = (content.services || []).map((s) => s.title);
  const doubled = [...items, ...items, ...items];
  return (
    <section className="bg-neutral-950 border-y border-neutral-800 py-6 overflow-hidden" data-testid="marquee-section">
      <div className="flex marquee-track whitespace-nowrap gap-16">
        {doubled.map((label, i) => (
          <div key={i} className="flex items-center gap-16 shrink-0">
            <span className="font-display uppercase font-black text-3xl md:text-4xl text-white tracking-tight">
              {label}
            </span>
            <span className="font-display uppercase font-black text-3xl md:text-4xl text-outline text-orange-500">
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
